import { Component, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';

import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog';
import { ProductTypeEnum } from '../../model/enums/ProductTypeEnum';

@Component({
  selector: 'app-configuration-page',
  templateUrl: './configuration-page.component.html',
  styleUrls: ['./configuration-page.component.css'],
})
export class ConfigurationPageComponent {
  activeTab = ProductTypeEnum.ORV;

  constructor(
    private keycloak: KeycloakService,
    public dialog: MatDialog
  ){}

  logout(): void {
    const confirmation = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: {
        confirmationMessage: 'Confirmations.SignOut',
        hasFreeText: false,
          optionalButtons: {
            confirmationYES: 'Yes',
            confirmationNO: 'No',
          },
      },
    });
    confirmation.componentInstance.yesEvent.subscribe(() => {
      this.keycloak.logout();
      confirmation.componentInstance.dialogRef.close();
    });
  }

  setActiveTab(product): void {
    this.activeTab = product;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return true;
  }
}
